module.exports = __webpack_public_path__ + "img/armenia.f675a356.svg";